__turbopack_context__.v({
  "circleButton": "SearchBar-module-scss-module__qv9VnW__circleButton",
  "fade-in": "SearchBar-module-scss-module__qv9VnW__fade-in",
  "input": "SearchBar-module-scss-module__qv9VnW__input",
  "root": "SearchBar-module-scss-module__qv9VnW__root",
  "submitButton": "SearchBar-module-scss-module__qv9VnW__submitButton",
  "submitContainer": "SearchBar-module-scss-module__qv9VnW__submitContainer",
  "textButton": "SearchBar-module-scss-module__qv9VnW__textButton",
});
